import type { StepperChangeDetail } from '../components/stepper'
import { pushEvent, type ViewHook } from '../helpers/utils'

type StepperHookContext = ViewHook & {
  _cleanup?: () => void
}

const isRecord = (value: unknown): value is Readonly<Record<string, unknown>> =>
  value !== null && typeof value === 'object'

const isStepperChange = (
  event: Event
): event is CustomEvent<StepperChangeDetail> =>
  event instanceof CustomEvent &&
  isRecord(event.detail) &&
  typeof event.detail.value === 'string'

const cleanup = (hook: StepperHookContext): void => {
  hook._cleanup?.()
  hook._cleanup = undefined
}

export const FacadeStepper = {
  mounted(this: StepperHookContext): void {
    cleanup(this)

    const handleChange = (event: Event): void => {
      const eventName = this.el.dataset.eventChange

      if (!(eventName && isStepperChange(event))) {
        return
      }

      const target = this.el.getAttribute('phx-target') ?? undefined

      pushEvent(this, eventName, { value: event.detail.value }, target)
    }

    this.el.addEventListener('facade-change', handleChange)
    this._cleanup = () =>
      this.el.removeEventListener('facade-change', handleChange)
  },

  destroyed(this: StepperHookContext): void {
    cleanup(this)
  }
}
